import { render, staticRenderFns } from "./AdminConfiguraciones.vue?vue&type=template&id=edcb4694&"
import script from "./AdminConfiguraciones.vue?vue&type=script&lang=js&"
export * from "./AdminConfiguraciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports